// extracted by mini-css-extract-plugin
export default {"skeletonBar":"_1dfnjmf","pills":"_xsh4ff","pill":"_h4nj60","search":"_1ifwtpz"};